import {authHeader} from '../_helpers'
import axios from 'axios'

export const invoiceService = {
  getInvoice,
  getEmployeeInvoices,
  getCustomerInvoices,
  getEmployeeInvoicesByInvoices,
  getCustomerInvoicesByInvoices,
  getEmployeeInvoicesByMonth,
  getCustomerInvoicesByMonth,
  releaseInvoice,
  releaseInvoicesByInvoices,
  releaseInvoicesByMonth,
  sendInvoice,
  sendInvoicesByInvoices,
  sendInvoicesByMonth,
  getTurnover
}

function getInvoice (invoiceId) {
  return axios.get(process.env.BASE_URL + '/api/invoices/' + invoiceId, {headers: authHeader(), responseType: 'blob'})
}

function getEmployeeInvoices (page, size) {
  return axios.get(process.env.BASE_URL + '/api/invoices/employee?lastMonthsToShow=4' + '&page=' + page + '&size=' + size, {headers: authHeader()})
}

function getCustomerInvoices (page, size) {
  return axios.get(process.env.BASE_URL + '/api/invoices/customer?lastMonthsToShow=4' + '&page=' + page + '&size=' + size, {headers: authHeader()})
}

function getEmployeeInvoicesByInvoices (invoiceIds) {
  return axios.post(process.env.BASE_URL + '/api/invoices/employee/bulk', invoiceIds, {headers: authHeader(), responseType: 'blob'})
}

function getCustomerInvoicesByInvoices (invoiceIds) {
  return axios.post(process.env.BASE_URL + '/api/invoices/customer/bulk', invoiceIds, {headers: authHeader(), responseType: 'blob'})
}

function getEmployeeInvoicesByMonth (month) {
  return axios.post(process.env.BASE_URL + '/api/invoices/employee/bulk/' + month, null, {headers: authHeader(), responseType: 'blob'})
}

function getCustomerInvoicesByMonth (month) {
  return axios.post(process.env.BASE_URL + '/api/invoices/customer/bulk/' + month, null, {headers: authHeader(), responseType: 'blob'})
}

function releaseInvoice (invoiceId) {
  return axios.post(process.env.BASE_URL + '/api/invoices/' + invoiceId + '/release', null, {headers: authHeader()})
}

function releaseInvoicesByInvoices (invoiceIds) {
  return axios.post(process.env.BASE_URL + '/api/invoices/bulk/release', invoiceIds, {headers: authHeader()})
}

function releaseInvoicesByMonth (month) {
  return axios.post(process.env.BASE_URL + '/api/invoices/bulk/release/' + month, null, {headers: authHeader()})
}

function sendInvoice (invoiceId) {
  return axios.post(process.env.BASE_URL + '/api/invoices/' + invoiceId + '/send-mail', null, {headers: authHeader()})
}

function sendInvoicesByInvoices (invoiceIds) {
  return axios.post(process.env.BASE_URL + '/api/invoices/bulk/send-mail', invoiceIds, {headers: authHeader()})
}

function sendInvoicesByMonth (month) {
  return axios.post(process.env.BASE_URL + '/api/invoices/bulk/send-mail/' + month, null, {headers: authHeader()})
}

function getTurnover (month) {
  return axios.get(process.env.BASE_URL + '/api/invoices/bulk/turnover/' + month, {headers: authHeader(), responseType: 'blob'})
}



// WEBPACK FOOTER //
// ./src/_services/invoice-service.js